export default __webpack_public_path__ + "logo-google-play-b44b0ab3dd7d5552fc37b88fdf06b97c.svg";